import { render, staticRenderFns } from "./ViewShipping.vue?vue&type=template&id=78eb87bf&scoped=true"
import script from "./ViewShipping.vue?vue&type=script&lang=ts"
export * from "./ViewShipping.vue?vue&type=script&lang=ts"
import style0 from "./ViewShipping.vue?vue&type=style&index=0&id=78eb87bf&prod&lang=scss&scoped=true"
import style1 from "./ViewShipping.vue?vue&type=style&index=1&id=78eb87bf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78eb87bf",
  null
  
)

export default component.exports